import { makeStyles, colors } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  questionText: {
    fontSize: 13,
    color: theme.palette.text.primary,
    whiteSpace: 'normal',
    lineHeight: 1.4,
  },
  answeredChip: {
    backgroundColor: colors.green[100],
    color: colors.green[800],
    fontWeight: 500,
    fontSize: 11,
  },
  pendingChip: {
    backgroundColor: colors.orange[100],
    color: colors.orange[800],
    fontWeight: 500,
    fontSize: 11,
  },
}))

export default styles
